import isNumber from "lodash/isNumber";

export const toSexagesimalScale = (latlong) => {
  let d = parseInt(latlong);
  let h = parseInt((latlong - d) * 60);
  let b = parseInt(((latlong - d) * 60 - h) * 60 * 1000) / 1000;
  let bst = (b + "").split(".");
  if (bst[1] === undefined) {
    bst[1] = "000"; // latlongが整数の場合、小数点以下がなくbst[1]がundefinedになるため、0埋め
  }
  return d + "°" + h + "'" + bst[0] + '"' + bst[1];
};

/**
 *  緯度経度(DD-MM.SSSS形式)を緯度経度(10進数)に変換
 *
 * @param coordinate "[13-25.0000,143-35.0000]"
 * @returns {number}
 */
export const d_msToDegree = (coordinate) => {
  let dd_lat;
  let mm_lat;
  let ss_lat;
  let latDeg;
  let split_lat_hyphen;
  let split_lat_comma = coordinate[0].split(".");
  if (split_lat_comma[0].startsWith("-")) {
    split_lat_comma[0] = split_lat_comma[0].slice(1);
    split_lat_hyphen = split_lat_comma[0].split("-");
    dd_lat = 90 - parseFloat(split_lat_hyphen[0]) + 180;
    mm_lat = parseFloat(split_lat_hyphen[1]) / 60;
    ss_lat = parseFloat(split_lat_hyphen[1]) / 3600;
  } else {
    split_lat_hyphen = split_lat_comma[0].split("-");
    dd_lat = parseFloat(split_lat_hyphen[0]);
    mm_lat = parseFloat(split_lat_hyphen[1] / 60);
    ss_lat = parseFloat(split_lat_hyphen[1]) / 3600;
  }
  latDeg = dd_lat + mm_lat + ss_lat;

  let dd_lng;
  let mm_lng;
  let ss_lng;
  let lngDeg;
  let split_lng_hyphen;
  let split_lng_comma = coordinate[1].split(".");
  if (split_lng_comma[0].startsWith("-")) {
    split_lng_comma[0] = split_lng_comma[0].slice(1);
    split_lng_hyphen = split_lng_comma[0].split("-");
    dd_lng = 180 - parseFloat(split_lng_hyphen[0]) + 180;
    mm_lng = parseFloat(split_lng_hyphen[1]) / 60;
    ss_lng = parseFloat(split_lng_comma[1]) / 3600;
  } else {
    split_lng_hyphen = split_lng_comma[0].split("-");
    dd_lng = parseFloat(split_lng_hyphen[0]);
    mm_lng = parseFloat(split_lng_hyphen[1] / 60);
    ss_lng = parseFloat(split_lng_comma[1]) / 3600;
  }
  lngDeg = dd_lng + mm_lng + ss_lng;
  return [lngDeg, latDeg];
};

const isValidLatitude = (latitude) => {
  if (!isNumber(latitude)) return false;
  return -90 <= latitude && latitude <= 90;
};

const isValidLongitude = (longitude) => {
  if (!isNumber(longitude)) return false;
  return -180 <= longitude && longitude <= 180;
};

const isNorthLatitude = (latitude) => {
  if (!isValidLatitude(latitude)) {
    throw new Error("Invalid latitude value: " + latitude);
  }
  return latitude >= 0;
};

const isEastLongitude = (longitude) => {
  if (!isValidLongitude(longitude)) {
    throw new Error("Invalid longitude value: " + longitude);
  }
  return longitude >= 0;
};

export default {
  toSexagesimalScale,
  d_msToDegree,
  isValidLatitude,
  isValidLongitude,
  isNorthLatitude,
  isEastLongitude,
};
